import { render, staticRenderFns } from "./GestionAseguramientoCalidad.vue?vue&type=template&id=65f59214&"
import script from "./GestionAseguramientoCalidad.vue?vue&type=script&lang=js&"
export * from "./GestionAseguramientoCalidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports